import { gql } from '@apollo/client'
import { Avatar, BodyText, Heading } from '@farol-ds/react'
import classNames from 'classnames'
import { useMemo } from 'react'

import {
  Comments_DocumentFragment,
  Comments_ViewerFragment,
} from './__generated__/comments.graphql'
import styles from './comments.module.scss'
import { PublishComment } from './components'
import { CommentList } from './components/commentList'

export interface CommentsProps {
  document: Comments_DocumentFragment
  viewer: Comments_ViewerFragment | null
  onLoadMore?: () => void
  className?: string
}

export function Comments(props: CommentsProps) {
  const { document, viewer, onLoadMore, className } = props

  const totalCommentsLabel = useMemo(() => {
    return `${document.numComments} ${document.numComments === 1 ? 'comentário' : 'comentários'}`
  }, [document.numComments])

  const classes = classNames(styles.container, className)

  return (
    <>
      <div className={classes}>
        <div className={styles.containerTitle} id="comments">
          <Heading size="xl" asChild>
            <p>{totalCommentsLabel}</p>
          </Heading>

          <div className={styles.avatar}>
            <Avatar
              size="lg"
              src={viewer?.thumborImage?.current || undefined}
              alt={viewer?.name || 'unlogged'}
              loading="lazy"
            />
            <BodyText size="md" asChild>
              <span>
                {viewer ? `${viewer.name}, f` : 'F'}aça comentário construtivo para esse documento
              </span>
            </BodyText>
          </div>
        </div>

        <PublishComment document={document} viewer={viewer} />
        <CommentList document={document} viewer={viewer} onLoadMore={onLoadMore} />
      </div>
    </>
  )
}

Comments.fragments = {
  document: gql`
    fragment Comments_document on Document {
      numComments
      ...PublishComment_document
      ...CommentList_document
    }

    ${PublishComment.fragments.document}
    ${CommentList.fragments.document}
  `,
  viewer: gql`
    fragment Comments_viewer on Profile {
      thumborImage {
        current: thumbUrl(size: "50x50")
      }
      name
      ...PublishComment_viewer
      ...CommentList_viewer
    }
    ${PublishComment.fragments.viewer}
    ${CommentList.fragments.viewer}
  `,
}
